

import { createSlice } from "@reduxjs/toolkit";
import { IOrder } from "../interface/IOrder";

const initialState: IOrder | null = null;

const orderTPSlice = createSlice({
    name: "orderTP",
    initialState,
    reducers: {
        setOrderInStore: (state: IOrder | null, action: any | null) => {
            return action.payload;
        },
        setOrderInStoreNull: (state, action) => {
            return null;
        }
    },
});


export const { setOrderInStore, setOrderInStoreNull } = orderTPSlice.actions;

export default orderTPSlice.reducer;
